import Api from '~/api'
import { resetForm, formSuccess, isLoading } from '~/form/actions'
import { push } from 'react-router-redux'
import { Map, List, fromJS } from 'immutable'

const entity = 'organization'
const entityPlurar = 'organizations'
const entityUpper = entity.toUpperCase()
const entityPlurarUpper = entityPlurar.toUpperCase()

/**
 * List of users
 */

export function fetch() {
  return (dispatch, getState) => {
    // if (getState()[entityPlurar]) return

    dispatch(fetchLoading(true))

    Api.get(`/${entity}`).then(({ data }) => {
      if (data.success) {
        dispatch(fetchSuccess(data.items))
      } else {
        dispatch(fetchError(true))
      }
    })
  }
}

export function fetchError(bool) {
  return {
    type: `${entityPlurarUpper}_FETCH_ERROR`,
    hasErrored: bool,
  }
}

export function fetchLoading(bool) {
  return {
    type: `${entityPlurarUpper}_FETCH_LOADING`,
    isLoading: bool,
  }
}

export function fetchSuccess(items) {
  return {
    type: `${entityPlurarUpper}_FETCH_SUCCESS`,
    items,
  }
}

/**
 * Fetch single item
 */

export function fetchItem(id) {
  return (dispatch, getState) => {
    dispatch(fetchItemLoading(true))

    Api.get(`/${entity}/${id}`)
      .then(({ data }) => {
        if (data.success) return dispatch(fetchItemSuccess(data.item))

        dispatch(fetchItemError(true))
      })
      .catch(err => dispatch(fetchItemError(true, err.message)))
  }
}

export function fetchItemError(bool, message = false) {
  return {
    type: `${entityUpper}_FETCH_ITEM_ERROR`,
    hasErrored: bool,
    message,
  }
}

export function fetchItemLoading(isLoading = true) {
  return {
    type: `${entityUpper}_FETCH_ITEM_LOADING`,
    isLoading,
  }
}

export function fetchItemSuccess(item) {
  return {
    type: `${entityUpper}_FETCH_ITEM_SUCCESS`,
    item,
  }
}

/**
 * Create organisation
 */

export function createOrganization(values, formId) {
  return async dispatch => {
    try {
      dispatch(createOrganizationLoading(true))
      let { data } = await Api.post('/organization', { item: values })

      if (data.success) {
        dispatch(resetForm(formId))
        dispatch(createOrganizationSuccess(data.item))
        dispatch(push(`/organization/${data.item.id}`))
      } else {
        dispatch(createOrganizationError(data.message))
        dispatch({
          type: 'FORM_SUBMIT_VALIDATION_ERROR',
          formId,
          errors: fromJS(data.errors || {}),
          messages: fromJS(data.messages || []),
        })
      }
    } catch (err) {
      console.log(err)
      dispatch(createOrganizationError(err.message || 'Error when creating organization'))
    }
  }
}
export function createOrganizationLoading(loading = true) {
  return {
    type: 'ORGANIZATION_CREATE_LOADING',
    loading,
  }
}

export function createOrganizationSuccess(item) {
  return {
    type: 'ORGANIZATION_CREATE_SUCCESS',
    item,
  }
}

export function createOrganizationError(message) {
  return {
    type: 'ORGANIZATION_CREATE_ERROR',
    message,
  }
}

/**
 * Update organisation
 */

export function updateOrganization(values, formId) {
  return async dispatch => {
    try {
      dispatch(updateOrganizationLoading(true))
      let { data } = await Api.patch(`/organization/${values.get('id')}`, { item: values })

      if (data.success) {
        dispatch(resetForm(formId))
        dispatch(updateOrganizationSuccess(data.item))
        dispatch(push(`/organization/${data.item.id}`))
      } else {
        dispatch(updateOrganizationError(data.message))
        dispatch({
          type: 'FORM_SUBMIT_VALIDATION_ERROR',
          formId,
          errors: fromJS(data.errors || {}),
          messages: fromJS(data.messages || []),
        })
      }
    } catch (err) {
      console.log(err)
      dispatch(updateOrganizationError(err.message || 'Error when creating organization'))
    }
  }
}
export function updateOrganizationLoading(loading = true) {
  return {
    type: 'ORGANIZATION_UPDATE_LOADING',
    loading,
  }
}

export function updateOrganizationSuccess(item) {
  return {
    type: 'ORGANIZATION_UPDATE_SUCCESS',
    item,
  }
}

export function updateOrganizationError(message) {
  return {
    type: 'ORGANIZATION_UPDATE_ERROR',
    message,
  }
}

export function updateSubscriptionRenewStatus(organization_id, subscription_id, renew_status) {
  return async dispatch => {
    try {
      dispatch({
        type: 'SUBSCRIPTION_RENEW_STATUS_LOADING',
        subscription_id,
        loading: true,
      })

      let { data } = await Api.patch(`/subscription/${organization_id}/renew`, { subscription_id, renew_status })

      if (data.success) {
        dispatch({
          type: 'SUBSCRIPTION_RENEW_STATUS_SUCCESS',
          subscription_id,
          table_id: 'subscriptions',
          renew_status: data.renew_status,
        })
      } else {
        throw Error(data.message)
      }
    } catch (err) {
      console.log(err)
      dispatch({
        type: 'SUBSCRIPTION_RENEW_STATUS_ERROR',
        message: err.message || 'Error when updating status',
        subscription_id,
      })
    }
  }
}

export function updateSubscriptionNotificationStatus(organization_id, subscription_id, notification_status) {
  return async dispatch => {
    try {
      dispatch({
        type: 'SUBSCRIPTION_NOTIFICATION_STATUS_LOADING',
        subscription_id,
        loading: true,
      })

      let { data } = await Api.patch(`/subscription/${organization_id}/notification`, {
        subscription_id,
        notification_status,
      })

      if (data.success) {
        dispatch({
          type: 'SUBSCRIPTION_NOTIFICATION_STATUS_SUCCESS',
          subscription_id,
          table_id: 'subscriptions',
          notification_status: data.notification_status,
        })
      } else {
        throw Error(data.message)
      }
    } catch (err) {
      console.log(err)
      dispatch({
        type: 'SUBSCRIPTION_NOTIFICATION_STATUS_ERROR',
        message: err.message || 'Error when updating status',
        subscription_id,
      })
    }
  }
}
